module.exports = __webpack_public_path__ + "img/weekly.38d6749a.png";